import { useMemo } from 'react';
import { htmlToText } from 'html-to-text';
import { Narrative } from '@/pages/PublicNarrativeAuthoring/hooks/useNarrativeById';

type Props = {
  narrative: Narrative;
};

export const useDescription = ({ narrative }: Props) => {
  const keyTakeaways = narrative.contentBlocks.find(
    (c) => c.title === 'Key Takeaways'
  );

  return useMemo(() => {
    if (!keyTakeaways) return '';
    const text = htmlToText(keyTakeaways, {
      wordwrap: false,
      ignoreHref: true,
      selectors: [
        {
          selector: 'ul',
          format: 'unorderedList',
          options: {
            itemPrefix: ' ',
          },
        },
        {
          selector: 'a',
          format: 'anchor',
          options: {
            ignoreHref: true,
          },
        },
      ],
    });
    return text.split('\n')[0];
  }, [keyTakeaways]);
};
